import React, { useState } from "react"
import { useAuth } from "../../lib/useAuth"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"
import { toast } from "react-toastify"
import MyModal from "../MyModal"
import Input from "../Input"
import { Spin } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import actionHelper from "../../lib/actionHelper"
import { createBannerBot } from "../../services/bannerBotApis"

const CreateBannerBotModal = ({ isOpen, toggleModal, price }) => {
    const { isConnected, sendMessage } = useSocket()
    const [loading, setLoading] = useState(false)
    const [templateNameIsValid, setTemplateNameIsValid] = useState(false)
    let debounceTimeout

    useSocketEvent("bannerTemplateNameIsValid", (isValid) => {
        setTemplateNameIsValid(isValid)
        setLoading(false)
    })

    const submitHandler = (e) => {
        e.preventDefault()
        if (!templateNameIsValid) {
            toast.error("اسم تمپلیت تکراری میباشد")
        }
        const form = new FormData(e.target)
        let data = {
            templateName: form.get("bot-template-name"),
            conn: {
                host: form.get("connection-host"),
                serverPort: form.get("connection-serverport"),
                queryPort: form.get("connection-queryport"),
                queryPassword: form.get("connection-querypassword"),
                username: form.get("connection-username"),
                botName: form.get("connection-botname"),
            },
        }

        actionHelper({
            confirmation: {
                label: `مقدار ${price} از حساب شما بابت ساخت بات کم میشود`,
                actionLabel: "تایید",
                color: "success",
            },
            texts: {
                success: "بات با موفقیت ساخته شد",
                pending: "در حال ساخت بات...",
            },
            callback: () => createBannerBot(data),
        })
    }

    const templateNameOnChangeHandler = (e) => {
        if (e.target.value == "") {
            setTemplateNameIsValid(false)
            return
        }
        setLoading(true)

        if (debounceTimeout) {
            clearTimeout(debounceTimeout)
            debounceTimeout = null
        }

        debounceTimeout = setTimeout(async () => {
            sendMessage("validateBannerTemplateName", { templateName: e.target.value })
        }, 1000)
    }

    return (
        <>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} height="500px" width="900px">
                <form classname="flex-col h-full" onSubmit={submitHandler}>
                    <div className="mx-14 h-full">
                        <h6 className="flex justify-center">ساخت بات داینامیک</h6>
                        <div className="mb-2">
                            <Input
                                onChange={templateNameOnChangeHandler}
                                type="text"
                                name="bot-template-name"
                                label="اسم تمپلیت*"
                                placeholder="Template Name"
                                autoComplete="off"
                                required
                            />
                        </div>
                        {loading ? (
                            <>
                                <Spin indicator={<LoadingOutlined spin />} size="small" />
                            </>
                        ) : (
                            <span>
                                <div
                                    class={`show_info text-sm ${templateNameIsValid ? "text-green-400" : "text-red-400"}`}
                                >
                                    {templateNameIsValid ? "معتبر" : "نامعتبر"}
                                </div>
                            </span>
                        )}
                        <div className="grid grid-cols-3 gap-5 mb-16">
                            <div className="">
                                <Input
                                    type="text"
                                    name="connection-host"
                                    label="ایپی سرور *"
                                    placeholder="ip/domain"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="">
                                <Input
                                    type="text"
                                    label="سرور پورت *"
                                    name="connection-serverport"
                                    placeholder="serverport"
                                    autoComplete="off"
                                    required
                                />
                            </div>

                            <div className="">
                                <Input
                                    type="text"
                                    label="پورت کوئری *"
                                    name="connection-queryport"
                                    placeholder="queryport"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-5">
                            <div className="">
                                <Input
                                    type="text"
                                    name="connection-username"
                                    label="یوزر کوئری *"
                                    placeholder="serveradmin"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="">
                                <Input
                                    type="text"
                                    name="connection-querypassword"
                                    label="پسورد کوئری *"
                                    placeholder="پسورد کوئری"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                        </div>
                        <div className="">
                            <Input
                                type="text"
                                name="connection-botname"
                                label="اسم بات *"
                                placeholder="اسم بات"
                                autoComplete="off"
                                required
                            />
                        </div>
                        <button type="submit" class="styled-button bottom-0  mt-5 ml-2 w-full success">
                            ساخت بات
                        </button>
                    </div>
                </form>
            </MyModal>
        </>
    )
}

export default CreateBannerBotModal
